import { useState } from 'react';
import PropTypes from 'prop-types';
import pdfImage from 'assets/icon-pdf.svg';
import docImage from 'assets/icon-doc.svg';
import photoImage from 'assets/photo.svg';
import { formatLongDate, formatFileSize } from 'Utils/formatters';
import Spinner from 'Components/Atoms/Spinner';
import Icon from 'Components/Atoms/Icon/Icon';
import { getInvoiceEmailFileDownloadUrl } from 'Services/invoices';
import { useErrors } from 'Components/Organisms/ErrorsProvider';

const getImageByType = (type) => {
    if (type.includes('pdf')) return pdfImage;
    if (type.includes('word')) return docImage;
    if (type.includes('image')) return photoImage;

    return docImage;
};

const download = (url, fileName) => {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default function InvoicesInboxEmailAttachment(props) {
    const { file, error, emailId } = props;
    const [loading, setLoading] = useState(false);

    const { showUnknownError } = useErrors();
    const handleDownload = async (ev) => {
        ev.preventDefault();
        if (loading) return;

        setLoading(true);
        try {
            const downloadUrl = await getInvoiceEmailFileDownloadUrl(emailId, file.id);
            download(downloadUrl, file.name);
        } catch (error) {
            showUnknownError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="grid grid-cols-[64px_1fr] gap-3 items-center">
                <a
                    href="#"
                    onClick={handleDownload}
                    className="flex items-center justify-center py-3 px-4 h-14 bg-gray-100 rounded"
                >
                    {loading && <Spinner size={24} />}
                    {!loading && <img src={getImageByType(file.type)} alt={file.type} />}
                </a>
                <div className="min-w-0">
                    <a
                        className="font-medium text-sm text-dark-blue truncate no-underline block"
                        href="#"
                        onClick={handleDownload}
                    >
                        {file.name}
                    </a>

                    <div className="flex items-center">
                        <span className="text-xs text-gray-500">{formatFileSize(file.size)}</span>
                        <span className="mx-1">·</span>
                        <span className="text-xs text-gray-500">{formatLongDate(file.creation_date)}</span>
                    </div>
                </div>
            </div>
            {error && (
                <div className="flex items-center gap-1 font-semibold text-xs pt-3 text-red-500">
                    <Icon name="exclamation-triangle" size={16} color="currentColor" />
                    <span>{error}</span>
                </div>
            )}
        </div>
    );
}

InvoicesInboxEmailAttachment.propTypes = {
    emailId: PropTypes.string.isRequired,
    file: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        creation_date: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
    error: PropTypes.string,
};
